import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { reportsApi } from '../api/reports-api';
import type { DayRange } from '../schemas/report-range';

import { reportKeys } from './report-keys';

export function supportReportQueryOptions(storeId: string, { from, to }: DayRange) {
  return queryOptions({
    queryKey: reportKeys.support(storeId, { from, to }),
    queryFn: () => reportsApi.support(storeId, { from, to }),
    placeholderData: keepPreviousData,
  });
}

export function useSupportReport(storeId: string, range: DayRange) {
  return useQuery(supportReportQueryOptions(storeId, range));
}
